
  import { defineComponent, inject } from "vue";

  import { helpers } from "@vuelidate/validators";
  import { get, isEmpty, set } from "lodash";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import fileUpload from "@/mixins/fileUpload";
  import { acceptedFileTypes, requiredFile } from "@/helpers/fileUploadValidators";

  export default defineComponent({
    name: "FileUploadV2",

    extends: BaseProcessComponentV2,

    mixins: [fileUpload],

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    computed: {
      name: {
        get(): string {
          if (this.file) {
            return this.file.name;
          }

          if (!this.documentId) {
            return "";
          }

          return get(this, "settings.attributes.filename", "") as string;
        },
        set(newValue: string | null) {
          set(this, `${this.path}.name`, newValue);
        },
      },
    },

    watch: {
      documentId: {
        immediate: true,
        handler(documentId: string | null) {
          if (documentId && isEmpty(this.value?.name)) {
            this.name = get(this, "settings.attributes.filename", "") as string;
          }
        },
      },
    },

    methods: {
      clear() {
        this.revokePreviewObjectUrl();
        this.file = null;
        this.error = null;
        this.value = null;
        this.resetInput();
        this.v$.$reset();
      },

      async getFile(event: Event): Promise<void> {
        const { files } = event.target as HTMLInputElement;
        const file: File | null = get(files, "0", null);
        this.error = null;

        if (!file) {
          return;
        }

        this.error = await this.validateFile(file);

        if (this.error) {
          this.resetInput();
          return;
        }

        this.file = file;

        this.contentType = get(file, "type", null);
        this.comments = get(this, "settings.attributes.comments", null) as string;
      },
    },

    validations() {
      const [root, ...rest] = this.path.split(".");
      const allowedMimeTypes: string[] = get(this.settings, "restrictions.allowedMimeTypes", []);

      const rules: any = { $autoDirty: true };

      if (get(this, "settings.attributes.required", false)) {
        rules.requiredFile = helpers.withMessage("Este campo es requerido.", requiredFile());
      }

      if (!isEmpty(allowedMimeTypes)) {
        rules.acceptedFileTypes = helpers.withMessage(
          "El tipo de archivo seleccionado es inválido.",
          acceptedFileTypes(allowedMimeTypes)
        );
      }

      const validations = {};
      set(validations, rest.join("."), rules);

      return {
        [root]: validations,
      };
    },
  });
